import { ActionTypes } from 'utils/constants';
import { getDeepProp } from 'utils/get-deep-prop';

const initialState = {};

export const userCurrentCourse = (state = initialState, action) => {
    switch(action.type) {
        case ActionTypes.USER_CURRENT_COURSE + '_PENDING': {            
            return {
                ...state,
                fetching: true
            };
        }
        case ActionTypes.USER_CURRENT_COURSE + '_FULFILLED': {  
            const course = getDeepProp(action, 'payload', 'data', 'course') || {};
          
            return {
                ...state,
                course
            };
        }
        case ActionTypes.USER_CURRENT_COURSE + '_REJECTED': {    
            const error = getDeepProp(action, 'payload', 'response', 'data', 'msg');
        
            return {
                ...state,
                fetching: false,
                fetched: false,
                error
            };
        }

        default: {
            return state;
        }
    }
};
